(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["checkout-popups-new"] && !Shopify.designMode) return;
  try {
    
  class CheckoutPopups extends HTMLElement {
    cartUpdateUnsubscriber = undefined;
    pfCartUpdateUnsubscriber = undefined;
    sequencePopups = [];
    sequenceIndex = 0;
    sequenceAcceptedPopups = [];

    constructor() {
      super();

      console.log('Consturctior');

      // Find first active, ignore other blocks
      this.block = this.querySelector('#CheckoutPopupsContent > [data-active-popup-block]');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.onCartClick = this.#onCartClick.bind(this);
      this.handleDesignModeSelect = this.#handleDesignModeSelect.bind(this);
      this.handleDesignModeDeselect = this.#handleDesignModeDeselect?.bind(this);
    }

    connectedCallback() {
      console.log('CheckoutPopups connected');

      const mainCheckoutButton = document.querySelector('#CartDrawer-Form');
      if (!mainCheckoutButton) {
        console.error('Main checkout button not found');
        return;
      }

      this.cartDrawer?.addEventListener('click', this.onCartClick);

      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (!event?.rerenderCheckoutPopups) {
          return;
        }

        this.#onCartUpdate();
      });
      this.pfCartUpdateUnsubscriber = subscribe('cart-updated', () => {
        this.#onCartUpdate();
      });

      document.addEventListener('shopify:block:select', this.handleDesignModeSelect);
      document.addEventListener('shopify:block:deselect', this.handleDesignModeDeselect);
    }

    disconnectedCallback() {
      if (!this.block) {
        return;
      }

      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
      if (this.pfCartUpdateUnsubscriber) {
        this.pfCartUpdateUnsubscriber();
      }
      if (this.cartDrawer) {
        this.cartDrawer.removeEventListener('click', this.onCartClick);
      }

      document.removeEventListener('shopify:block:select', this.handleDesignModeSelect);
      document.removeEventListener('shopify:block:deselect', this.handleDesignModeDeselect);
    }

    #onCartClick(e) {
      if (e.target.id !== 'CartDrawer-Checkout') {
        return;
      }

      if (!this.block) {
        return;
      }

      this.#disableCheckoutFields();
      this.#disableParams();

      switch (this.block.getAttribute('data-popup-type')) {
        case 'popup':
          this.block.classList.add('checkout-popup-show');

          const video = this.block.querySelector('video');
          if (video) video.play();

          e.preventDefault();

          const attributesJSON = JSON.parse(
            this.block.querySelector('script[data-checkout-popup-attributes]')?.innerText || '{}'
          );
          this.#updateAttributes(attributesJSON);
          break;
        case 'sequence': {
          this.sequencePopups = [...this.block.querySelectorAll('[data-popup-type="popup"]')];
          this.sequenceIndex = 0;
          this.sequenceAcceptedPopups = [];

          if (!this.sequencePopups.length) {
            this.#enableAllCheckoutFields();
            this.#enableAllParams();
            break;
          }

          e.preventDefault();

          const firstPopup = this.sequencePopups[0];
          firstPopup.classList.add('checkout-popup-show');
          const firstVideo = firstPopup.querySelector('video');
          if (firstVideo) firstVideo.play();

          const firstAttributesJSON = JSON.parse(
            firstPopup.querySelector('script[data-checkout-popup-attributes]')?.innerText || '{}'
          );
          this.#updateAttributes(firstAttributesJSON);
          break;
        }
        case 'split': {
          const splitPopups = [...this.block.querySelectorAll('[data-popup-type="popup"]')];

          if (!splitPopups.length) {
            this.#enableAllCheckoutFields();
            this.#enableAllParams();
            break;
          }

          e.preventDefault();

          const splitIndex = Math.floor(Math.random() * splitPopups.length);
          const chosenPopup = splitPopups[splitIndex];
          const variantLetter = String.fromCharCode(65 + splitIndex);
          const splitId = this.block.getAttribute('data-split-id');

          chosenPopup.classList.add('checkout-popup-show');
          const splitVideo = chosenPopup.querySelector('video');
          if (splitVideo) splitVideo.play();

          const splitAttributesJSON = JSON.parse(
            chosenPopup.querySelector('script[data-checkout-popup-attributes]')?.innerText || '{}'
          );
          this.#updateAttributes({
            ...splitAttributesJSON,
            [`__split-popup-${splitId}-v-${variantLetter}`]: 'true',
          });
          break;
        }
      }
    }

    #onCartUpdate() {
      fetch(`${Shopify.routes.root}?section_id=${this.dataset.sectionId}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selector = '#CheckoutPopupsContent';
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
            this.block = this.querySelector('#CheckoutPopupsContent > [data-active-popup-block]');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }

    async accept(e) {
      const popup = e.target.closest('[data-active-popup-block]');
      const variantIdToAdd = popup.getAttribute('data-variant');

      switch (this.block.getAttribute('data-popup-type')) {
        case 'popup':
        case 'split':
          if (!variantIdToAdd) {
            this.#resetAndClose(popup);
            return;
          } else {
            this.#startLoadingBtn(popup);
            await this.#addToCartAndCheckout([{ id: variantIdToAdd, quantity: 1 }], popup);
            this.#stopLoadingBtn(popup);
            this.#resetAndClose(popup);
          }
          break;

        case 'sequence':
          if (variantIdToAdd) {
            this.#startLoadingBtn(popup);
            await this.#addToCart([{ id: variantIdToAdd, quantity: 1 }]);
            this.#stopLoadingBtn(popup);
          }
          this.sequenceAcceptedPopups.push(popup);
          this.#advanceSequence(popup);
          break;
      }
    }

    reject(e) {
      const popup = e.target.closest('[data-active-popup-block]');
      const cartForm = document.querySelector('#CartDrawer-Form');

      switch (this.block.getAttribute('data-popup-type')) {
        case 'popup':
        case 'split':
          this.#resetAndClose(popup);
          this.#enableCheckoutField(popup);
          cartForm.submit();
          break;
        case 'sequence':
          this.#advanceSequence(popup);
          break;
      }
    }

    #startLoadingBtn(popup) {
      const confirmBtn = popup.querySelector('.drawer__checkout-popup-accept');
      if (!confirmBtn) return;
      confirmBtn.classList.add('loading');
      confirmBtn.querySelector('.loading__spinner')?.classList.remove('hidden');
    }

    #stopLoadingBtn(popup) {
      const confirmBtn = popup.querySelector('.drawer__checkout-popup-accept');
      if (!confirmBtn) return;
      confirmBtn.classList.remove('loading');
      confirmBtn.querySelector('.loading__spinner')?.classList.add('hidden');
    }

    #resetAndClose(popup) {
      if (!popup) return;
      popup.classList.remove('checkout-popup-show');
      popup.classList.remove('second-checkout-popup--shown');
      popup.querySelectorAll('video').forEach((el) => el.pause());
    }

    #advanceSequence(currentPopup) {
      currentPopup.classList.remove('checkout-popup-show');
      currentPopup.querySelectorAll('video').forEach((v) => v.pause());

      this.sequenceIndex++;
      const nextPopup = this.sequencePopups[this.sequenceIndex];

      if (nextPopup) {
        nextPopup.classList.add('checkout-popup-show');
        const nextVideo = nextPopup.querySelector('video');
        if (nextVideo) nextVideo.play();

        try {
          const nextAttributesJSON = JSON.parse(
            nextPopup.querySelector('script[data-checkout-popup-attributes]')?.innerText || '{}'
          );
          this.#updateAttributes(nextAttributesJSON);
        } catch (error) {
          console.error(error);
        }
      } else {
        this.#finalizeSequence();
      }
    }

    #finalizeSequence() {
      for (const popup of this.sequenceAcceptedPopups) {
        this.#enableParams(popup);
      }

      if (this.block) {
        this.block.querySelectorAll("[data-checkout-popup-input][name='checkout']").forEach((c) => {
          c.removeAttribute('disabled');
          c.setAttribute('form', c.dataset.form);
        });
      }

      try {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-form',
          rerenderCheckoutPopups: false,
        });
      } catch (e) {
        console.error(e);
      }

      setTimeout(() => {
        document.querySelector('#CartDrawer-Form').submit();
      }, 500);
    }

    async #addToCartAndCheckout(items, popup) {
      await this.#addToCart(items);
      try {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-form',
          rerenderCheckoutPopups: false,
        });
      } catch (e) {
        console.error(e);
      }

      setTimeout(() => {
        this.#enableParams(popup);
        this.#enableCheckoutField(popup);
        document.querySelector('#CartDrawer-Form').submit();
      }, 500);
    }

    async #addToCart(items) {
      try {
        const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items }),
        });
        if (!res.ok) {
          throw new Error('Failed to add item to cart');
        }
      } catch (error) {
        console.error(error);
      }
    }

    async #updateAttributes(obj = {}) {
      try {
        if (!Object.keys(obj).length) {
          return;
        }
        await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            attributes: obj,
          }),
        });
      } catch (error) {
        console.error(error);
      }
    }

    #enableCheckoutField(popup) {
      const checkoutInput = popup.querySelector("[name='checkout']");
      if (!checkoutInput) return;
      checkoutInput.removeAttribute('disabled');
      checkoutInput.setAttribute('form', checkoutInput.dataset.form);
    }

    #disableCheckoutFields() {
      document.querySelectorAll("[data-checkout-popup-input][name='checkout']").forEach((c) => {
        c.setAttribute('disabled', 'disabled');
        c.removeAttribute('form');
      });
    }

    #enableAllCheckoutFields() {
      document.querySelectorAll("[data-checkout-popup-input][name='checkout']").forEach((c) => {
        c.removeAttribute('disabled');
        c.setAttribute('form', c.dataset.form);
      });
    }

    #enableParams(popup) {
      try {
        const cartForm = document.querySelector('#CartDrawer-Form');
        const [path, query = ''] = cartForm.getAttribute('action').split('?');
        const searchParams = new URLSearchParams(query);

        const url = new URL(cartForm.action, window.location.origin);
        let paramsEntries = [];
        try {
          paramsEntries = JSON.parse(popup.querySelector('[data-checkout-popup-params]')?.innerText || '[]');
        } catch (e) {
          console.error(e);
        }
        for (const [key, value] of paramsEntries) {
          searchParams.set(key, value);
        }
        cartForm.setAttribute('action', `${path}${searchParams.toString() ? `?${searchParams.toString()}` : ``}`);
      } catch (error) {
        console.error(error);
      }
    }

    #disableParams() {
      try {
        const cartForm = document.querySelector('#CartDrawer-Form');
        const [path, query = ''] = cartForm.getAttribute('action').split('?');
        const searchParams = new URLSearchParams(query);

        const url = new URL(cartForm.action, window.location.origin);
        let paramsEntries = [];
        try {
          paramsEntries = [...document.querySelectorAll('[data-checkout-popup-params]')]
            .map((s) => JSON.parse(s.innerText || '[]'))
            .flat();
        } catch (e) {
          console.error(e);
        }
        for (const [key] of paramsEntries) {
          searchParams.delete(key);
        }
        cartForm.setAttribute('action', `${path}${searchParams.toString() ? `?${searchParams.toString()}` : ``}`);
      } catch (error) {
        console.error(error);
      }
    }

    #enableAllParams() {
      try {
        const cartForm = document.querySelector('#CartDrawer-Form');
        const [path, query = ''] = cartForm.getAttribute('action').split('?');
        const searchParams = new URLSearchParams(query);

        let paramsEntries = [];
        try {
          paramsEntries = [...document.querySelectorAll('[data-checkout-popup-params]')]
            .map((s) => JSON.parse(s.innerText || '[]'))
            .flat();
        } catch (e) {
          console.error(e);
        }
        for (const [key, value] of paramsEntries) {
          searchParams.set(key, value);
        }
        cartForm.setAttribute('action', `${path}${searchParams.toString() ? `?${searchParams.toString()}` : ``}`);
      } catch (error) {
        console.error(error);
      }
    }

    #handleDesignModeSelect(event) {
      const blockId = event?.detail?.blockId;
      if (!blockId) {
        return;
      }

      const popup = this.querySelector(`[data-block-id="${blockId}"]`);
      if (!popup) {
        return;
      }

      popup.classList.add('checkout-popup-show');
      const video = popup.querySelector('video');
      if (video) video.play();
    }

    #handleDesignModeDeselect(event) {
      const blockId = event?.detail?.blockId;
      if (!blockId) {
        return;
      }

      const popup = this.querySelector(`[data-block-id="${blockId}"]`);
      if (!popup) {
        return;
      }

      popup.classList.remove('checkout-popup-show');
      const video = popup.querySelector('video');
      if (video) video.pause();
    }
  }

  customElements.define('checkout-popups', CheckoutPopups);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
